import {
  ENDPOINTS,
  SIGNUP,
  VERIFY,
  PASSWORD,
  PROVIDERS,
  SERVICES,
  REGIONS,
  ZONES,
  IMAGES,
  SIZES,
  TIMEZONES,
  PROJECTS,
  ESTIMATES,
  WORKSTATIONS,
  DISPLAY_GATEWAYS,
  CONTAINERS,
  DATABASES,
  NODES,
  CHARGE,
  USAGE,
  MEASUREMENTS,
  INVITES,
  SCHEDULES,
  INVOICES,
  VPN_GATEWAYS,
  SNOWFLAKES,
  USERNAME,
  CONNECTIONS,
  ENTITIES
} from "../actions/actionConstants.js";

import { singleEntityReducer } from "./entity/singleEntityReducer.js";
import { entityReducer } from "./entity/entityReducer.js";
import { ephemeralEntityReducer } from "./entity/ephemeralEntityReducer.js";

import { apiReducer } from "./api/apiReducer.js";
import { configReducer } from "./config/configReducer.js";
import { localeReducer } from "./locale/localeReducer.js";
import { authenticationReducer } from "./authentication/authenticationReducer.js";
import { coreReducer } from "./core/coreReducer.js";
import { accountReducer } from "./account/accountReducer.js";
import { watchersReducer } from "./core/watchersReducer.js";
import { projectWizardReducer } from "./projectWizard/projectWizardReducer.js";
import { notificationReducer } from "./notifications/notificationReducer.js";
import { systemNotificationReducer } from "./notifications/systemNotificationReducer.js";

const reducers = {
  config: configReducer,
  locale: localeReducer,
  endpoints: entityReducer(ENDPOINTS),

  api: apiReducer,
  authentication: authenticationReducer,
  signup: singleEntityReducer(SIGNUP),
  verify: singleEntityReducer(VERIFY),
  core: coreReducer,
  account: accountReducer,
  password: singleEntityReducer(PASSWORD),
  username: singleEntityReducer(USERNAME),
  watchers: watchersReducer,

  providers: entityReducer(PROVIDERS),
  services: entityReducer(SERVICES),
  regions: entityReducer(REGIONS),
  zones: entityReducer(ZONES),
  images: entityReducer(IMAGES),
  sizes: entityReducer(SIZES),
  timezones: entityReducer(TIMEZONES),

  projects: entityReducer(PROJECTS),
  connections: entityReducer(CONNECTIONS),
  projectWizard: projectWizardReducer,
  estimates: entityReducer(ESTIMATES, false),
  workstations: entityReducer(WORKSTATIONS, false),
  displaygateways: entityReducer(DISPLAY_GATEWAYS, false),
  virtualprivatenetworkgateways: entityReducer(VPN_GATEWAYS, false),
  containers: entityReducer(CONTAINERS, false),
  databases: entityReducer(DATABASES, false),
  nodes: entityReducer(NODES, false),
  snowflakes: entityReducer(SNOWFLAKES, false),
  charge: entityReducer(CHARGE, false),
  usage: entityReducer(USAGE, false),
  measurements: entityReducer(MEASUREMENTS),

  invites: entityReducer(INVITES),
  schedules: entityReducer(SCHEDULES),
  invoices: entityReducer(INVOICES),

  ephemeralEntities: ephemeralEntityReducer(ENTITIES, false),
  notifications: notificationReducer,
  systemNotifications: systemNotificationReducer
};

export default reducers;
